import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
	apiKey: "AIzaSyCQ_OvOxA1cq1mM9ZJi7APPiONO-zFFXjg",
	authDomain: "netflix-clone-69d7e.firebaseapp.com",
	projectId: "netflix-clone-69d7e",
	storageBucket: "netflix-clone-69d7e.appspot.com",
	messagingSenderId: "276118050034",
	appId: "1:276118050034:web:8f6ffd0698da760e906c6b"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth();

export { auth };

export default db;
